import { getObjectKeysAsObject } from "@checkout/helpers";
import { ParentState } from "@checkout/types";
import type { PartialParentContextWithHtsAirCfar } from "./types";

export const guards = {
  hasHtsCfarIdAndEnabled: (
    ctx: PartialParentContextWithHtsAirCfar,
    _event: unknown
  ) => ctx[ParentState.htsAirCfar].selectedOffer != null,
};

export const GuardTypes = getObjectKeysAsObject(guards);
